module.exports = __webpack_public_path__ + "static/media/Indorse-Whitepaper-v1.1.a733cc8e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/brand/Indorse-Whitepaper-v1.1.pdf
// module id = 1273
// module chunks = 146